"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFlowNavigationRole = exports.FLOW_NAVIGATION_ROLES = exports.FLOW_LIFECYCLE_ROLES = void 0;
exports.FLOW_LIFECYCLE_ROLES = [
    'app-start',
    'account-create',
    'sign-in',
    'sign-out',
    'account-delete',
    'external-exit',
];
exports.FLOW_NAVIGATION_ROLES = [
    'global',
    'forward',
    'back',
    'related',
];
const isFlowNavigationRole = (value) => exports.FLOW_NAVIGATION_ROLES.some(role => role === value);
exports.isFlowNavigationRole = isFlowNavigationRole;
